import React, { lazy, Suspense } from "react";
import { BrowserRouter as Router, Routes, Route, useLocation } from "react-router-dom";
import Header from "./components/Header";
import Footer from "./components/Footer";
import CustomCursor from "./components/CustomCursor";
import ScrollDepthCTA from "./components/ScrollDepthCTA";
import GlobalInteractions from "./components/GlobalInteractions";
import ScrollToTop from "./hooks/ScrollToTop";
import "./styles.css";

const Home               = lazy(() => import("./pages/Home"));
const Capabilities       = lazy(() => import("./pages/Capabilities"));
const Contact            = lazy(() => import("./pages/Contact"));
const WebsiteDevelopment = lazy(() => import("./pages/WebsiteDevelopment"));
const About              = lazy(() => import("./pages/About"));
const CaseStudies        = lazy(() => import("./pages/CaseStudies"));
const PageNotFound       = lazy(() => import("./pages/PageNotFound"));

/**
 * AppContent must live inside <Router> so it can call useLocation.
 * The key={location.key} on the wrapper div causes React to unmount
 * and remount it on every navigation, which re-triggers the
 * .page-enter CSS animation for a smooth page transition.
 */
function AppContent() {
  const location = useLocation();
  return (
    <Suspense fallback={<div className="page-loading-fallback" />}>
      <div key={location.key} className="page-enter">
        <Routes>
          <Route path="/"                element={<Home />} />
          <Route path="/web-development" element={<WebsiteDevelopment />} />
          <Route path="/capabilities"    element={<Capabilities />} />
          <Route path="/about"           element={<About />} />
          <Route path="/case-studies"    element={<CaseStudies />} />
          <Route path="/contact"         element={<Contact />} />
          <Route path="*"                element={<PageNotFound />} />
        </Routes>
      </div>
    </Suspense>
  );
}

function App() {
  return (
    <Router>
      <CustomCursor />
      <ScrollToTop />
      <GlobalInteractions />
      <Header />
      <AppContent />
      <Footer />
      <ScrollDepthCTA />
    </Router>
  );
}

export default App;
